import { createSelector } from "reselect";

const getStateNavSelector = (state) => state.nav;

export const getLanguageSelector = createSelector(
  getStateNavSelector,
  (nav) => {
    if (nav?.language) {
      return nav.language;
    }

    return undefined;
  }
);

export const getLineSelector = createSelector(getStateNavSelector, (nav) => {
  if (nav?.line) {
    return nav.line;
  }

  return undefined;
});

export const getFilterPartSelector = createSelector(
  getStateNavSelector,
  (nav) => {
    if (nav?.filterPart) {
      return nav.filterPart;
    }

    return undefined;
  }
);

export const getFilterPartDesSelector = createSelector(
  getStateNavSelector,
  (nav) => {
    if (nav?.filterPartDes) {
      return nav.filterPartDes;
    }

    return undefined;
  }
);

export const getFilterCodeSelector = createSelector(
  getStateNavSelector,
  (nav) => {
    if (nav?.filterCode) {
      return nav.filterCode;
    }

    return undefined;
  }
);

export const getFilterTaskSelector = createSelector(
  getStateNavSelector,
  (nav) => {
    if (nav?.filterTask) {
      return nav.filterTask;
    }

    return undefined;
  }
);

export const getFilterVivSelector = createSelector(
  getStateNavSelector,
  (nav) => {
    if (nav?.filterViv) {
      return nav.filterViv;
    }

    return undefined;
  }
);

export const getFilterVarietySelector = createSelector(
  getStateNavSelector,
  (nav) => {
    if (nav?.filterVariety) {
      return nav.filterVariety;
    }

    return undefined;
  }
);

export const getFilterBatchSelector = createSelector(
  getStateNavSelector,
  (nav) => {
    if (nav?.filterBatch) {
      return nav.filterBatch;
    }

    return undefined;
  }
);

export const getFilterArticleSelector = createSelector(
  getStateNavSelector,
  (nav) => {
    if (nav?.filterArticle) {
      return nav.filterArticle;
    }

    return undefined;
  }
);

export const getFilterLocationSelector = createSelector(
  getStateNavSelector,
  (nav) => {
    if (nav?.filterLocation) {
      return nav.filterLocation;
    }

    return undefined;
  }
);

export const getFilterSectSelector = createSelector(
  getStateNavSelector,
  (nav) => {
    if (nav?.filterSect) {
      return nav.filterSect;
    }

    return undefined;
  }
);

export const getFilterUserSelector = createSelector(
  getStateNavSelector,
  (nav) => {
    if (nav?.filterUser) {
      return nav.filterUser;
    }

    return undefined;
  }
);
